<!--  -->
<template>
  <div class="mycourse-page">
    <div class="ui-modal">
      <div class="ui-modal-mask">

      </div>
    </div>
    <div class="w1200" style="width: 700px">
      <div class="paomadeng" v-if="top_msg" @click="toMsgShow(top_msg)">
        <div class="left">
          <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2701" width="100%" height="100%"><path d="M192 736 192 416C192 261.184 301.952 132.064 448 102.4L448 64C448 28.64 476.64 0 512 0 547.36 0 576 28.64 576 64L576 102.4C722.048 132.064 832 261.184 832 416L832 736 864.096 736C899.392 736 928 764.416 928 800 928 835.36 899.36 864 864.096 864L159.904 864C124.608 864 96 835.584 96 800 96 764.64 124.64 736 159.904 736L192 736ZM608 928C608 981.024 565.024 1024 512 1024 458.976 1024 416 981.024 416 928L608 928Z" p-id="2702"></path></svg>
          消息通知
        </div>
        <div class="right">
          <marquee direction="left" loop="loop">{{top_msg.title}}</marquee>
        </div>
      </div>
    </div>
    <template v-if="courseNum">
      <div class="">
        <div class="learning_timeline-wrapper w1200" style="margin-top: 1rem">
          <div class="learning_timeline-line"></div>
          <div class="learning_timeline-line-top"  @click="openTimetable">
            <img src="~assets/index_v2/icon_kebiao_rili_2.png" alt="">
          </div>
          <div class="learning_timeline-line-bottom" v-if="courseNum>1"></div>
          <div v-for="(dateItem,dateIndex) in calendarData">
            <div v-for="(course,courseIndex) in dateItem.course">
              <div class="learning_timeline_item">
                <course_status
                    :data="course"
                    @enterRoom="enterRoom"
                    @updateLive="updateLive"
                />
                <course_range
                    :data="course"
                    :index="courseIndex"
                />
                <template v-if="dateIndex && (courseIndex===0)">
                  <div class="learning_timeline-line-point">
                    <img src="~assets/index_v2/icon_kebiao_rulib.png" alt="">
                  </div>
                </template>
                <div class="learning_content">
                    <course_join
                        :data="course"
                        @enterRoom="enterRoom"
                        @updateLive="updateLive"
                    />
                  <div class="learning_head">
                    <img style="width:16px" src="~assets/index_v2/icon_kebiao_neirong.png" alt="" />
                    课程内容
                  </div>
                  <div class="learning_body">
                    {{course.course_type}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TimetableModal
          @enterRoom="enterRoom"
          :markDateMore="calendarTable"
          @fetchData="fetchCalendar"
          :visible.sync="modalVisible"
      >
      </TimetableModal>
    </template>
    <template v-else>
      <section class="empty0-section" style="width: 500px">
        <img src="~assets/index_v2/no-paike.png" alt="" />
      </section>
    </template>
    <div class="mycourse-footer">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import { fetchTimetable, fetchCalendar,getTopMsg } from "@/services";
import { Timeline, Tooltip } from "ant-design-vue";
import TimetableModal from "./timetableModal";
import course_join from "./course_join";
import course_status from "./course_status";
import course_range from "./course_range";
import Footer from "@/components/layout/Footer";

import { formatData2Calendar } from "./utils";
import { mapState } from "vuex";
import { enterStatus } from "@/utils/format-tools";
import { enterRoom } from "@/utils/tools";
const qs = require("querystring");

export default {
  name: "myCourse",
  components: {
    ATimeline: Timeline,
    ATimelineItem: Timeline.Item,
    ATooltip: Tooltip,
    TimetableModal,
    course_join,
    course_status,
    course_range,
    Footer
  },
  data() {
    return {
      top_msg:[],
      padUrl: process.env.VUE_APP_PADURL,
      modalVisible: false,
      todayCourse: [],
      calendarData: [],
      calendarTable: [],
      livingCurr: "",
      courseNum: 0,
      originData: {}
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      brand_info: state => state.brand_info
    })
  },
  watch: {},
  methods: {
    openwindow (url, name, iWidth, iHeight) {
      var iTop = (window.screen.height - 30 - iHeight) / 2       //获得窗口的垂直位置;
      var iLeft = (window.screen.width - 10 - iWidth) / 2        //获得窗口的水平位置;

      window.open(url, name, 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',toolbar=no,menubar=no,scrollbars=auto,resizeable=no,location=no,status=no')
    },
    toMsgShow(item){
      if(item.type===2){
        this.$router.push({
          path: '/msg',
          query: {
            id:item.id,
          }
        })
      }
      if(item.type===3){
        this.openwindow(item.url,'',700,650);
      }
    },
    openTimetable() {
      this.modalVisible = true;
    },
    enterRoom(data) {
      enterRoom(data, this);
    },
    updateLive(data) {
      data = data || this.originData;
      for (let key in data) {
        if (Array.isArray(data[key])) {
          for (let i = 0; i < data[key].length; i++) {
            const { timecountdown, s_time, e_time } = data[key][i];
            const { pre_in_class, after_in_class } = data[key][i].config;
            this.courseNum += 1;
            if (
              enterStatus({
                timecountdown,
                s_time,
                e_time,
                pre_in_class,
                after_in_class
                }) === 0
            ) {
              this.livingCurr = data[key][i];
            }
          }
        }
      }
    },
    fetchCalendar (date) {
      fetchCalendar({
        type: "" + this.userInfo.is_assist,
        date: date || ''
      }).then(res => {
        if (res.code === 1) {
          let data = res.data;
          this.calendarTable = formatData2Calendar(data);
        }
      });
    }
  },
  created() {
    if(this.brand_info.single_user_data){
      this.$router.replace({
        path: '/mycourse_v1',
      })
    }
  },
  mounted() {
    fetchTimetable({
      type: "" + this.userInfo.is_assist
    }).then(res => {
      if (res.code === 1) {
        this.originData = res.data;
        this.calendarData = formatData2Calendar(res.data);
        this.updateLive(res.data)
      }
    });
    this.fetchCalendar()
    getTopMsg().then((res)=>{
      if(res.data){
        this.top_msg=res.data[0];
      }
    });
  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {}
};
</script>
<style lang="less" scoped>
/* @import url(); 引入公共css类 */
@import url("./index.less");

.ui-modal{
  //width: 800px;
  //transform-origin: -165.5px 139px;
  box-sizing: border-box;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  top: 100px;
  width: auto;
  margin: 0 auto;
  padding-bottom: 24px;
  pointer-events: none;
}
.ui-modal-warp{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  overflow: auto;
  outline: 0;
  -webkit-overflow-scrolling: touch;
}
.ui-modal-mask {
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  filter: alpha(opacity=50);
}

marquee{
  width:100%;
}
@keyframes marqueeAnim {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}

.marquee-content {
  white-space: nowrap;
  display: inline-block;
  color: chocolate;
  overflow: hidden;
  animation: marqueeAnim 3s linear 0s infinite;
}

.marquee-box{
  width: 300px;
  height: 30px;
  text-align: left;
  line-height: 30px;
  overflow: hidden;
  background-color: burlywood;
}

.paomadeng{
  display: flex;
  border: 2px solid #27BFA3;
  .left{
    color: #fff;
    background: #27BFA3;
    width: 100px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 5px;
  }
  .right{
    flex:1;
    box-sizing: border-box;
    padding: 5px;
    white-space: nowrap;
  }
  svg{
    fill:#fff;
    width: 15px;
    height: 15px;
  }
}

.learning_timeline-wrapper{
  width: 700px;
  display: block;
  position: relative;
  .learning_timeline-line{
    display: block;
    position: absolute;
    width: 1px;
    background-color: #3BA485;
    height: 100%;
    left: -4rem;
  }
  .learning_timeline-line-top{
    position: absolute;
    background-color: #fff;
    height: 6rem;
    width: 6rem;
    left: -7rem;
    top:0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    img{
      height: 45px;
      width: 35px;
      margin-top: 1.5rem;
    }
  }
  .learning_timeline-line-bottom{
    display: block;
    position: absolute;
    background-color: #fff;
    height: 10rem;
    width: 6rem;
    left: -7rem;
    bottom:0;
  }
  .learning_timeline-line-point{
    display: block;
    position: absolute;
    //background-color: blue;
    height: 3rem;
    width: 3rem;
    left: -5rem;
    top:2.3rem;
  }
}
.learning_timeline_item{
  padding: 2rem;
  border-radius: 10px;
  position: relative;
  min-height: 160px;
  margin-bottom: 1rem;
  border: 1px solid rgba(112, 201, 177, 1);
  background-color: rgba(242, 255, 246, 1);
  .learning_content{
    display: block;
    margin-top: 4rem;
    background-color: rgb(255, 253, 242);
    border-radius: 8px;
    position:relative;
    .learning_head{
      padding: .5rem 1rem;
      font-size: 16px;
      color:rgba(59, 164, 133, 1);
    }
    .learning_body{
      padding:.5rem 1rem;
      font-weight: bold;
      font-size: 16px;
      color:rgba(38, 38, 38, 1);
    }
  }
}
</style>